<template>
  <li class="bohemia-header-nav-item">
    <div class="bohemia-header-wrapper">
      <div v-if="user && user.username">
        <Dropdown
          :items="accountItems"
          id="account"
          placement="right"
          :openItem="open"
          @onOpen="onOpen"
        >
          <template slot-scope="props">
            <a
              @click="props.onClick"
              class="bohemia-header-button"
              :class="{ active: active }"
              href="javascript:void(0)"
              data-active="false"
            >
              <span class="bohemia-header-name">{{ user.username }} </span>
              <span class="bohemia-header-icon">
                <img :src="avatarImage" width="25px" height="25px" />
              </span>
            </a>
          </template>
          <template slot="items">
            <li class="bohemia-header-nav-item">
              <a :href="logoutUrl" class="bohemia-header-nav-item-button">
                <span>Logout</span>
              </a>
            </li>
          </template>
        </Dropdown>
      </div>
      <template v-else>
        <a id="bohemia-header-login-button" :href="loginUrl">
          <span id="bohemia-header-button-login-text">LOG IN</span>
          <img
            id="bohemia-header-button-login-icon"
            src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4NCA4NCIgY2xhc3M9IiIgc3R5bGU9IiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiM3NTk5ZGM7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjRweDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmdseXBocy1iaXN0dWRpby11c2VyLXN0cm9rZWQ8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSBDcmJYc3Brdl8wIiBkPSJNMiw0MkE0MCw0MCAwLDEsMSA4Miw0MkE0MCw0MCAwLDEsMSAyLDQyIj48L3BhdGg+PHBhdGggY2xhc3M9ImNscy0xIENyYlhzcGt2XzEiIGQ9Ik0yOS40LDI2LjNBMTIuOSwxMy44IDAsMSwxIDU1LjE5OTk5OTk5OTk5OTk5NiwyNi4zQTEyLjksMTMuOCAwLDEsMSAyOS40LDI2LjMiPjwvcGF0aD48cGF0aCBjbGFzcz0iY2xzLTEgQ3JiWHNwa3ZfMiIgZD0iTTUyLjMsNDAuN2MxLjUsMS44LDguMywxMCw4LjMsMjEuNywwLDAtNC45LDYuNS0xNy44LDcuNWgtMWMtMTMtMS0xNy44LTcuNS0xNy44LTcuNSwwLTExLjcsNi45LTE5LjgsOC4zLTIxLjciPjwvcGF0aD48c3R5bGU+LkNyYlhzcGt2XzB7c3Ryb2tlLWRhc2hhcnJheToyNTIgMjU0O3N0cm9rZS1kYXNob2Zmc2V0OjI1MzthbmltYXRpb246Q3JiWHNwa3ZfZHJhdyA1MDBtcyBlYXNlLWluIDBtcyBmb3J3YXJkczt9LkNyYlhzcGt2XzF7c3Ryb2tlLWRhc2hhcnJheTo4NCA4NjtzdHJva2UtZGFzaG9mZnNldDo4NTthbmltYXRpb246Q3JiWHNwa3ZfZHJhdyA1MDBtcyBlYXNlLWluIDBtcyBmb3J3YXJkczt9LkNyYlhzcGt2XzJ7c3Ryb2tlLWRhc2hhcnJheTo4OCA5MDtzdHJva2UtZGFzaG9mZnNldDo4OTthbmltYXRpb246Q3JiWHNwa3ZfZHJhdyA1MDBtcyBlYXNlLWluIDBtcyBmb3J3YXJkczt9QGtleWZyYW1lcyBDcmJYc3Brdl9kcmF3ezEwMCV7c3Ryb2tlLWRhc2hvZmZzZXQ6MDt9fUBrZXlmcmFtZXMgQ3JiWHNwa3ZfZmFkZXswJXtzdHJva2Utb3BhY2l0eToxO305MS40ODkzNjE3MDIxMjc2NyV7c3Ryb2tlLW9wYWNpdHk6MTt9MTAwJXtzdHJva2Utb3BhY2l0eTowO319PC9zdHlsZT48L3N2Zz4="
            width="25px"
            height="25px"
          />
        </a>
      </template>
    </div>
  </li>
</template>

<script>
import navigationData from "../../../config/header/nav";

import Dropdown from "./../partials/Dropdown";
import userIcon from "./../../../assets/svg/user_animated.svg";

export default {
  name: "bohemia-login-register",
  components: { Dropdown },
  props: {
    authBaseUrl: String,
    registerPath: String,
    loginPath: String,
    logoutPath: String,
    user: Object,
    gravatarUrl: String,
    avatarUrl: String,
    avatar: {
      type: String,
      default: "gravatar",
    },
    open: {},
  },
  computed: {
    active() {
      return this.open === "account";
    },
    avatarImage: function() {
      const gravatarParams = "?&r=r&s=151&d=404";

      if (
        this.user &&
        this.user.avatars &&
        this.user.avatars.default &&
        this.user.avatars.default.url
      ) {
        switch (this.avatar) {
          case "gravatar":
            return this.user.avatars.default.url + gravatarParams;
            break;
        }
      }

      if (this.gravatarUrl) {
        return this.gravatarUrl + gravatarParams;
      }

      if (this.avatarUrl) {
        return this.avatarUrl;
      }

      return userIcon;
    },
    accountItems: function() {
      return navigationData.account;
    },
    registerUrl: function() {
      if (this.registerPath) {
        return this.registerPath;
      }

      return this.authBaseUrl + "auth/register";
    },
    loginUrl: function() {
      if (this.loginPath) {
        return this.loginPath;
      }

      return this.authBaseUrl + "auth/login";
    },
    logoutUrl: function() {
      if (this.logoutPath) {
        return this.logoutPath;
      }

      return this.authBaseUrl + "auth/logout";
    },
  },
  methods: {
    onOpen(id) {
      this.$emit("onOpen", id);
    },
  },
  mounted: function() {
    const evt = new CustomEvent("bohemiaHeaderLoaded");
    window.dispatchEvent(evt);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "/../../../assets/scss/breakpoints";
@import "/../../../assets/scss/header/colors";

#bohemia-header-register-button,
#bohemia-header-login-button {
  display: inline-block;
  text-decoration: none;
}

// TODO: not used anywhere
#bohemia-header-register-button {
  color: #989898;
  transition: color 0.5s;

  &:hover {
    color: #6ba539;
  }

  @media (max-width: $brSmall) {
    display: none;
  }
}

#bohemia-header-login-button {
  color: #6ba539;
  border: 1px solid #6ba539;
  border-radius: 30px;
  line-height: 2;
  padding: 0 25px;
  font-weight: bold;
  font-size: 1em;
  transition: background 0.5s;

  &:hover {
    background: #000;
  }

  #bohemia-header-button-login-icon {
    vertical-align: middle;
    display: none;
  }

  @media (max-width: $brSmall) {
    padding: 0 15px;
    font-size: 1em;
    border: none;

    #bohemia-header-button-login-text {
      display: none;
    }

    #bohemia-header-button-login-icon {
      display: inline-block;
    }
  }
}

.bohemia-header-name {
  color: #fff;
  animation: fadein 1.5s;
  transition: color 0.5s;
  text-overflow: ellipsis;
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: middle;

  @media (max-width: $brSmall) {
    display: none !important;
  }
}

.bohemia-header-wrapper {
  .bohemia-header-icon {
    margin-left: 10px;
    padding-left: 10px;
    border-left: 1px solid rgba(255, 255, 255, 0.14);
    vertical-align: middle;

    img {
      border-radius: 50%;
      transition: box-shadow 0.5s;
    }

    @media (max-width: $brSmall) {
      border: none;
      padding-left: 0;
    }
  }

  span {
    line-height: 1;
    display: inline-block;
    font-family: Palanquin Dark, sans-serif;
  }

  .bohemia-header-button {
    &:hover,
    &.active {
      .bohemia-header-name {
        color: $colorHighlight !important;
      }

      .bohemia-header-icon {
        img {
          box-shadow: 0 0 10px 2px transparentize($colorHighlight, 0.5);
        }
      }
    }
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
